import { BringzzIcon } from "@bringzz/components";

const MapControls = ({ onLocationClick }) => {
    return (
        <div className="absolute bottom-10 right-3 flex flex-col gap-2 z-10">
            <button 
                className="bg-white w-10 h-10 rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 transition-colors"
                onClick={onLocationClick}
            >
                <BringzzIcon
                    icon="IconGeoLocation"
                    folder="HealthIcons"
                    size="20"
                    className="p-2"
                />
            </button>
        </div>
    );
};

export default MapControls; 